export default __webpack_public_path__ + "static/pderquibio-b24463a4cbe71792b1922da669405c44.pdf";